import { apirequest } from "../../helpers/api-client";
import { newApi } from "../restdux/index";

export const surveyManager = newApi("survey", "/api/survey/");
export const reducer = surveyManager.reducer;

export function fetchSurveys(blockId) {
  return surveyManager.actions.list({ block: blockId });
}

export function fetchSurvey(surveyId) {
  return surveyManager.actions.get({ id: surveyId });
}

export function createSurvey(data) {
  return surveyManager.actions.create(data);
}

export function updateSurvey(data) {
  return surveyManager.actions.update(data);
}

export function deleteSurvey(id) {
  return surveyManager.actions.del({ id });
}

export function closeSurvey(surveyId, { skipNotifications = false } = {}) {
  return () =>
    apirequest("post", `/api/survey/${surveyId}/close/`).send({
      skip_notifications: skipNotifications,
    });
}
